export default "__VITE_ASSET__ba715a16__"